import CurrencyStepper from './currency-stepper';
export default CurrencyStepper;
